import { z } from "zod";

import { INSURANCE_ELIGIBILITY, InsuranceEligibility } from "./types";

export const insuranceSchema = z.object({
  id: z.number(),
  name: z.string(),
  ehr_id: z.number().optional(),
  eligibility: z.enum(
    Object.values(INSURANCE_ELIGIBILITY) as [
      InsuranceEligibility,
      ...InsuranceEligibility[],
    ],
  ),
  covers_coaching: z.boolean().optional(),
  bypasses_nirvana_check: z.boolean().optional(),
});
